import styled from 'styled-components'
import { mq, pxToRem, sizes } from 'src/theme'
import ActionButton from 'src/components/ActionButton'

import MainLayout from '../../layouts/MainLayout'

export const Layout = styled(MainLayout)``

export const Wrapper = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  display: flex;
  gap: ${pxToRem(20)};
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${pxToRem(12)};
`

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.d1440_body}
`

export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.d1440_h1};
  color: ${({ theme }) => theme.colors.black};
  text-align: center;

  @media ${mq(null, sizes.tablet)} {
    ${({ theme }) => theme.textStyles.d1440_h2};
  }
`

export const Button = styled(ActionButton)``
